import { combineReducers } from "redux";
import equipments from "./Equipments";
import furnituresReducer from "./Furnitures";

export default combineReducers({
  workstationEquipments: equipments,
  workstationFurnitures: furnituresReducer
});
